module.exports = "https://www.gc-qa.gnp.com.mx/6b03046f4c161c15cb3573f876205a39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/notificacion_active.svg
// module id = 1853
// module chunks = 0